<template>
  <v-container
    id="dashboard"
    fluid
    tag="section"
  >
    <v-snackbar
      v-model="snackbar"
      xs12
      multi-line
      :timeout="timeout"
      top
      color="orange"
    >
      {{ alertmessage }}
      <v-btn
        color="white"
        text
        @click="snackbar = false"
      >
        Close
      </v-btn>
    </v-snackbar>
    <sequential-entrance from-top>
      <v-row class="hidden-md-and-down">
        <v-col
          v-for="button in menuforstatus"
          :key="button.nav"
          class="justify-space-around"
        >
          <base-material-card
            v-if="!loading"
            :color="button.color"
            :icon="button.icon"
            inline
            link
            :to="gettopurl(button.nav)"
          >
            <template v-slot:after-heading>
              <div class="display-1 font-weight-light">
                {{ button.text }}
              </div>
            </template>
          </base-material-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-card>
            <v-card-title class="primary white--text">
              *Important Notice*
            </v-card-title>
            <v-card-text class="ma-2 pa-2">
              <div
                class="orange--text display-2"
              >
                You must create a new label for each shipment. Shipping labels are only able to be printed 1 hour from creation.
              </div>
              <div
                class="orange--text display-2"
              >
                Please remember to accurately complete your deposit ticket and place in your bag with the ticket visibly shown.
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <base-material-card
            color="primary"
            icon="mdi-truck"
            inline
          >
            <template v-slot:after-heading>
              <div class="display-2 font-weight-light">
                Ship packages for {{ sitedetails.idnum }} Shipments created this month: {{ numshipmentsmonth }} <br>Shipments Allowed Per Month: {{ numshipmentconfig }}
              </div>
            </template>
            <v-data-table
              :headers="headers"
              :items="getpostalshipments"
              :single-expand="singleExpand"
              :expanded.sync="expanded_deposits"
              :items-per-page="10"
              :search="search"
              sort-by="timestamp"
              sort-desc
              item-key="timestamp"
              show-expand
              class="elevation-1"
            >
              <template v-slot:top>
                <v-toolbar
                  flat
                  color="white"
                >
                  <v-divider
                    class="mx-4"
                    inset
                    vertical
                  />
                  <v-spacer />
                  <v-dialog
                    v-model="dialog"
                    max-width="500px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-btn
                        color="warning"
                        dark
                        class="mb-2"
                        to="/Postalactions"
                      >
                        Return
                      </v-btn>
                      <v-btn
                        color="primary"
                        dark
                        class="mb-2 mr-4"
                        v-on="on"
                      >
                        New Shipment
                      </v-btn>
                    </template>
                    <v-card>
                      <v-card-title>
                        <span class="headline">{{ formTitle }}</span>
                      </v-card-title>

                      <v-card-text>
                        <v-container>
                          <v-row>
                            <v-col
                              cols="12"
                              sm="12"
                              md="12"
                            >
                              {{ sitedetails.idnum }}
                            </v-col>
                            <v-col
                              v-if="!shipmentavailable"
                              cols="12"
                              sm="12"
                              md="12"
                              class="red--text font-weight-bold display-2"
                            >
                              Sorry no more shipments can be created this month
                            </v-col>
                            <v-col>
                              <!-- LETS SEE IF WE WANT TO DO THIS AT ALL FIRST
                    <v-col cols="12" sm="12" md="12" v-if="editedItem.contents">
                      Current Contents
                    </v-col>

                    <v-data-table v-if="editedItem.contents"
                        :headers="itembagheaders"
                        :items="getbagsofshipment(editedItem.contents)"
                        item-key="BagNumber"
                      >
                    </v-data-table>
                    -->
                              <v-data-table
                                v-model="selected"
                                :headers="bagheaders"
                                :items="getpostaldeposits"
                                item-key="timestamp"
                              >
                                <template v-slot:[`item.securebagdeposit.DepositAmount`]="{ item }">
                                  {{ format_amt(item.securebagdeposit.DepositAmount) }}
                                </template>
                                <template v-slot:no-data>
                                  <div class="display-2 font-weight-light">
                                    Sorry, there are no bags logged to ship. Empty shipments are not allowed.
                                  </div>
                                  <br>
                                </template>
                              </v-data-table>
                            </v-col>
                            <v-col
                              cols="12"
                              sm="12"
                              md="12"
                            >
                              Package Total is <b>{{ totalShipment }}</b>
                            </v-col>
                            <v-col
                              cols="12"
                              sm="12"
                              md="12"
                            >
                              Shipment Insruance Limit is <b v-if="userGroup === 'fahertybrand'">$2,500.00</b>
                              <b v-if="userGroup !== 'fahertybrand'">$5,000.00</b>
                            </v-col>
                            <v-col
                              cols="12"
                              sm="12"
                              md="12"
                            >
                              Shipping Address Info: {{ sitedetails.address }}, {{ sitedetails.city }} {{ sitedetails.state }} {{ sitedetails.zipcode }}
                            </v-col>
                            <v-col
                              cols="12"
                              sm="12"
                              md="12"
                            >
                              Contact: {{ sitedetails.sitecontactname }}, {{ sitedetails.sitecontactnumber }}
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-card-text>

                      <v-card-actions>
                        <v-spacer />
                        <v-btn
                          color="blue darken-1"
                          text
                          @click="close"
                        >
                          Cancel
                        </v-btn>
                        <v-btn
                          color="blue darken-1"
                          :disabled="!shipmentavailable || !bagstoship"
                          text
                          @click="savelabel"
                        >
                          Create
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-toolbar>
              </template>

              <template v-slot:[`item.carrier`]="{ item }">
                USPS
              </template>
              <template v-slot:[`item.label`]="{ item }">
                <a
                  v-if="shipmentexpired(item)"
                  :href="getlabelpdfurl(item)"
                  target="_blank"
                >
                  <v-icon color="green">mdi-file-pdf-box</v-icon>
                </a>
                <v-icon
                  v-else
                  color="black"
                >
                  mdi-truck-fast
                </v-icon>
              </template>
              <template v-slot:[`item.manifest`]="{ item }">
                <v-btn
                  v-if="shipmentexpired(item)"
                  outlined
                  small
                  color="deep-purple darken-1"
                  dark
                  @click="generatepdf(item)"
                >
                  <v-icon>mdi-download</v-icon>
                </v-btn>

                <v-icon
                  v-else
                  color="brown darken-1"
                >
                  mdi-clock
                </v-icon>
              </template>
              <template v-slot:[`item.timestamp`]="{ item }">
                {{ format_time(item.timestamp) }}
              </template>

              <template v-slot:[`item.amount`]="{ item }">
                {{ format_amt(item.securebagdeposit.DepositAmount) }}
              </template>
              <template v-slot:[`item.bagid`]="{ item }">
                {{ item.securebagdeposit.BagNumber }}
              </template>
              <template v-slot:[`item.trackingnumber`]="{ item }">
                {{ item.tracking_number }}
              </template>
              <template v-slot:[`item.vaultstatus`]="{ item }">
                Pending
              </template>
              <template v-slot:[`item.action`]="{ item }">
                <v-btn
                  small
                  fab
                  class="mr-2"
                  color="primary"
                  @click="editItem(item)"
                >
                  <v-icon dark>
                    mdi-plus
                  </v-icon>
                </v-btn>
              </template>
              <template v-slot:[`item.shipit`]="{ item }">
                <v-btn
                  small
                  fab
                  class="mr-2"
                  color="warning"
                  @click="editItem(item)"
                >
                  <v-icon dark>
                    mdi-truck
                  </v-icon>
                </v-btn>
              </template>
              <template v-slot:no-data>
                Sorry, No info {{ sitedetails.idnum }}
              </template>

              <template v-slot:expanded-item="{ headers, item }">
                <td :colspan="headers.length">
                  <v-card class="my-0">
                    <v-card-text>
                      <base-subheading
                        subheading="Deposit Transit Events"
                      />
                      <base-subheading
                        :subheading="item.trackdata.carrier_status_description"
                      />
                      <base-material-tabs
                        icons-and-text
                        vertical
                        color="warning"
                      >
                        <v-tab
                          v-for="(tab, i) in item.trackdata.events"
                          :key="i"
                        >
                          {{ tab.city_locality }}
                          <v-icon>
                            mdi-map-marker
                          </v-icon>
                        </v-tab>
                        <v-tab-item
                          v-for="(tab, i) in item.trackdata.events"
                          :key="i"
                        >
                          <v-card
                            color="white"
                            class="pa-4 ma-4"
                          >
                            <v-card-title>
                              {{ tab.description }} Occured at: {{ tab.occurred_at }}
                            </v-card-title>
                            <v-card-text>
                              {{ tab.city_locality }} {{ tab.postal_code }} {{ tab.state_province }} {{ tab.country_code }}
                            </v-card-text>
                            <v-card-text>
                              Shipper Event Code: {{ tab.event_code }} Shipper Status Code: {{ tab.status_code }}
                            </v-card-text>
                            <v-card-text>
                              Latitude: {{ tab.latitude }} Longitude: {{ tab.longitude }}
                            </v-card-text>
                            <br>
                          </v-card>
                        </v-tab-item>
                      </base-material-tabs>
                    </v-card-text>
                  </v-card>
                </td>
              </template>
            </v-data-table>
          </base-material-card>

          <div class="py-3" />
        </v-col>
      </v-row>
    </sequential-entrance>
  </v-container>
</template>

<script>
  import moment from 'moment'
  import { utcToZonedTime, format, zonedTimeToUtc } from 'date-fns-tz'
  import { jsPDF } from 'jspdf'
  const axios = require('axios')
  var numeral = require('numeral')
  var jrQrcode = require('jr-qrcode')

  export default {
    name: 'Depositusersbysite',
    props: ['id'],
    data: () => ({
      dialog: false,
      selected: [],
      loading: false,
      sitedetails: '',
      snackbar: false,
      unit_id: '',
      timeout: 7000,
      singleSelect: false,
      search: '',
      alertmessage: '',
      baglist: [],
      headers: [
        { text: 'Created', align: 'left', value: 'timestamp', sortable: true },
        { text: 'Tracking ID', align: 'left', value: 'trackingnumber', sortable: true },
        { text: 'Label', align: 'center', value: 'label', sortable: true },
        { text: 'Manifest', align: 'center', value: 'manifest', sortable: true },
        { text: 'Count', align: 'center', value: 'count', sortable: true },
        { text: 'Amount', align: 'center', value: 'amt', sortable: true },
      ],
      bagheaders: [
        { text: 'Bag ID', align: 'center', value: 'securebagdeposit.BagNumber', sortable: true },
        { text: 'Deposit Amount', align: 'center', value: 'securebagdeposit.DepositAmount', sortable: true },
      ],
      itembagheaders: [
        { text: 'Bag ID', align: 'center', value: 'BagNumber', sortable: true },
        { text: 'Deposit Amount', align: 'center', value: 'DepositAmount', sortable: true },
      ],
      shipments: [],
      expanded: [],
      expanded_deposits: [],
      singleExpand: true,
      editedIndex: -1,
      editedItem: {
        safeid: '',
        bags: [],
        idnum: '',
        timestamp: '',
        allowedusers: '',
        duration: '',
        washifyid: '',
        source: '',
        status: '',
        userid: '',
        amount: '',
      },
      defaultItem: {
        safeid: '',
        idnum: '',
        bags: [],
        timestamp: '',
        duration: '',
        allowedusers: '',
        washifyid: '',
        status: '',
        userid: '',
        amount: '',
        source: '',
      },
    }),

    computed: {
      userGroup () {
        let group = 'unknown'
        group = this.$store.getters.user.group
        return group
      },
      menuforstatus () {
        if (this.$store.getters.user.status === 'storemanager') {
          return []
        } else if (this.$store.getters.user.status === 'groupmanager') {
          return []
        } else if (this.$store.getters.user.status === 'corporate') {
          return [
            {
              text: 'Create Bags',
              value: 'deposits',
              color: 'pink',
              icon: 'mdi-shopping-outline',
              nav: '/Depositpost/'
            },
            {
              text: 'Tracking',
              value: 'cit',
              color: 'green',
              icon: 'mdi-transfer-right',
              nav: '/Deposittracking/'
            },
          ]
        } else if (this.$store.getters.user.status === 'admin') {
          return [
            {
              text: 'Create Bags',
              value: 'deposits',
              color: 'pink',
              icon: 'mdi-shopping-outline',
              nav: '/Depositpost/'
            },
            {
              text: 'Tracking',
              value: 'cit',
              color: 'green',
              icon: 'mdi-transfer-right',
              nav: '/Deposittracking/'
            },
          ]
        }
      },
      formIsValid () {
        return this.editedItem.email !== '' &&
          this.editedItem.accesscode !== '' &&
          this.editedItem.username !== ''
      },
      formTitle () {
        let title = 'Add Bags'
        if (this.editedIndex === -1) {
          title = 'New Shipment'
        }
        return title
      },
      getpostaldeposits () {
        let securitybags = this.$store.getters.getLoadedPostalDeposits.filter(deposit => deposit.shipped !== true)
        this.selected = securitybags
        return securitybags
      },
      totalShipment () {
        let total = 0
        this.selected.forEach(item => {
          total += parseFloat(item.securebagdeposit.DepositAmount)
        })
        return numeral(total).format('$0.00')
      },
      contentspresent () {
        if (this.selected) {
          if (this.selected.length <= 0) {
            console.log('nothing to ship')
            return false
          }
        }
        return true
      },
      bagstoship () {
        let bagstoship = false
        if (this.selected) {
          if (this.selected.length > 0) {
            bagstoship = true
          }
        }
        return bagstoship
      },
      shipmentavailable () {
        // if no contents, then do not allow
        let shipmentsallowed = numeral(this.sitedetails.shipmentspermonth).value()
        let currentmonth = moment().format('MM')
        let shipmentsinmonth = 0
        let yearshipments = []
        let currentyear = moment().format('YYYY')
        console.log('current year ', currentyear)
        if (this.$store.getters.getLoadedPostalShipments) {
          this.$store.getters.getLoadedPostalShipments.forEach(entry => {
            if (moment(entry.timestamp).format('YYYY') === currentyear) {
              yearshipments.push(entry)
            }
          })
        }
        let currentshipments = yearshipments.map(entry => moment(entry.timestamp).format('MM'))

        shipmentsinmonth = numeral(currentshipments.filter(shipment => shipment === currentmonth).length).value()
        if (shipmentsinmonth < shipmentsallowed) {
          return true
        }
        return false
      },
      numshipmentsmonth () {
        let yearshipments = []
        let currentyear = moment().format('YYYY')
        console.log('current year ', currentyear)
        if (this.$store.getters.getLoadedPostalShipments) {
          this.$store.getters.getLoadedPostalShipments.forEach(entry => {
            if (moment(entry.timestamp).format('YYYY') === currentyear) {
              yearshipments.push(entry)
            }
          })
        }
        console.log('this years shipments ', yearshipments)
        yearshipments.forEach(entry => {
          if (entry.timestamp) {
            console.log('timestamp ', moment(entry.timestamp).format('YYYY-MM'))
          }
        })
        let currentshipments = yearshipments.map(entry => moment(entry.timestamp).format('MM'))
        let currentmonth = moment().format('MM')
        let shipmentsinmonth = currentshipments.filter(shipment => shipment === currentmonth)
        console.log('current week ', currentmonth, ' shipments in month ', shipmentsinmonth, this.$store.getters.getLoadedPostalShipments)

        return shipmentsinmonth.length
      },
      numshipmentconfig () {
        let shipmentsallowed = this.sitedetails.shipmentspermonth
        let currentshipments = this.$store.getters.getLoadedPostalShipments.map(entry => moment(entry.timestamp).format('MM'))
        let currentweek = moment().format('MM')
        let shipmentsinmonth = currentshipments.filter(shipment => shipment === currentweek)
        return shipmentsallowed
      },
      getpostalshipments () {
        let recs = this.$store.getters.getLoadedPostalShipments
        for (let record of recs) {
          let sum = 0
          let end = recs.length - 1
          // if (index === end) {
          //   record.label = 'used'
          // }
          if (record.contents) {
            record.contents.forEach(item => {
              sum += parseFloat(item.securebagdeposit.DepositAmount)
            })
            Object.assign(record, { count: record.contents.length })
            Object.assign(record, { amt: numeral(sum).format('$0.00') })
          }
        }
        this.shipments = recs
        // get count of the contents
        // get total amount of the bags
        return this.shipments
      },

      getshipments () {

      }
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      loading (val) {
        if (!val) return

        setTimeout(() => (this.loading = false), 1000)
      }
    },

    created () {
      this.id = this.$route.params.id
      this.getsitemap(this.id)
      this.$log.debug('LOADING THIS ID ', this.id)
      this.initialize()
    },
    beforeDestroy () {
      // this.$store.dispatch('stoprealtimepostalshipments', this.id)
    },
    methods: {
      initialize () {
      },
      formatForZone (timestamp) {
        let timezone = this.sitedetails.timezone
        let sitetimezone
        let output
        let pattern = 'yyyy-MM-dd HH:mm:ss'

        if (timezone === 'EST') {
          sitetimezone = 'America/New_York'
        } else if (timezone === 'CST') {
          sitetimezone = 'America/Chicago'
        } else if (timezone === 'PST') {
          sitetimezone = 'America/Los_Angeles'
        } else if (timezone === 'MST') {
          sitetimezone = 'America/Denver'
        } else if (timezone === 'GMT') {
          sitetimezone = 'Europe/London'
        }
        let zonedTime = utcToZonedTime(timestamp, sitetimezone)
        output = format(zonedTime, pattern, { sitetimezone })
        return output
      },
      gettopurl (nav) {
        let url = nav + this.$route.params.id
        return url
      },
      format_time (ts) {
        this.$log.debug('TS ', ts)
        return this.formatForZone(ts)
      },
      format_amt (amt) {
        this.$log.debug('amt ', amt)
        return numeral(amt).format('$0,0.00')
      },
      getlabelpdfurl (data) {
        let url = ''
        if (data.label_download) {
          url = data.label_download.pdf
        }
        return url
      },
      shipmentexpired (shipment) {
        if (this.$store.getters.user.status === 'admin') {
          return true
        }
        let recs = this.$store.getters.getLoadedPostalShipments
        // find the greatest timestamp
        // compare it to the
        // sort recs by timestamp
        let lastrec = recs[recs.length - 1]
        const MAX_SHIPMENT_PRINT_TIME = 1
        if (shipment.timestamp === lastrec.timestamp) {
          if (moment().diff(lastrec.timestamp, 'hours') < MAX_SHIPMENT_PRINT_TIME) {
            return true
          }
        }
      },
      getlastshipment (shipment) {
        // loop thru all shipments
        // find the most recent shipping label
        // see if it matches shipment ID passed
        //   if yes, give icon for the pdf
        let recs = this.$store.getters.getLoadedPostalShipments
        // find the greatest timestamp
        // compare it to the
        // sort recs by timestamp
        let lastrec = recs[recs.length - 1]
        if (shipment.timestamp === lastrec.timestamp) {
          return true
        }
        return false
      },
      // these are bags which are already part of this specific shipment
      getbagsofshipment (contents) {
        let bags = []
        if (contents) {
          contents.forEach(entry => {
            let details = { BagNumber: entry.securebagdeposit.BagNumber, DepositAmount: entry.securebagdeposit.DepositAmount }
            bags.push(details)
          })
        }

        return bags
      },
      generatepdf (item) {
        const doc = new jsPDF()
        let uniquebags = [...new Set(item.contents.map(entry => entry.securebagdeposit.BagNumber))]

        doc.setFontSize(22)
        doc.text('Paythings Security Bag Manifest', doc.internal.pageSize.getWidth() / 2, 20, { align: 'center' })
        doc.text('Please include this inside the package', doc.internal.pageSize.getWidth() / 2, 30, { align: 'center' })
        doc.text(item.siteid, doc.internal.pageSize.getWidth() / 2, 40, { align: 'center' })
        doc.text('Security Bag count: ' + uniquebags.length, doc.internal.pageSize.getWidth() / 2, 50, { align: 'center' })
        // loop through security bags in this package
        let step = 10
        let ypos = 70
        uniquebags.forEach(item => {
          let bagidlist = ''
          let pos = ypos + step
          ypos += step
          bagidlist += 'Bag ID ' + item
          doc.text(bagidlist, 55, pos, { align: 'center' })
        })
        // item.contents.forEach(secbag => {
        //   let bagidlist = ''
        //   let pos = ypos + step
        //   ypos += step
        //   bagidlist += 'Bag ID ' + secbag.securebagdeposit.BagNumber
        //   doc.text(bagidlist, 55, pos, { align: 'center' })
        // })
        let imgBase64 = jrQrcode.getQrBase64(item.tracking_number)
        doc.addImage(imgBase64, 'JPEG', 110, 70, 75, 75)

        doc.save(item.siteid + item.tracking_number + '.pdf')
        this.alertmessage = 'Downloading Manifest code for ' + item.siteid
        this.snackbar = true
      },
      getsitemap (machineid) {
        this.$log.debug('sitemap')
        for (let [key, value] of Object.entries(this.$store.getters.loadedSiteProfiles)) {
          // this.$log.debug(`${key}: ${value}`)
          if (value.siteunitsprofile) {
            if (value.siteunitsprofile[0].crypto_idnum === machineid) {
              this.$log.debug(value)
              this.sitedetails = this.$store.getters.loadedSites.find(location => value.idnum === location.idnum)
              console.log('OUR SITE DETAILS ')
            }
          }
        }
        this.$store.dispatch('loadpostalbags', machineid)
        this.$store.dispatch('loadpostaldeposits', machineid)
        this.$store.dispatch('loadpostalshipments', machineid)
      },
      editItem (item) {
        this.editedIndex = this.shipments.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
        this.$log.debug('this is an edit')
      },

      deleteItem (item) {
        const index = this.shipments.indexOf(item)
        this.$log.debug('site info is ', item)
        if (confirm('Are you sure you want to delete this item?') && this.shipments.splice(index, 1)) {
          this.$log.debug('site info is ', item.key)
          let rec = {
            key: item.key,
            siteid: this.id
          }
          // this.$store.dispatch('removePendingDeposit', rec)
        }
      },
      baglist (machineid) {
        return ['one', 'two']
      },
      close () {
        this.dialog = false
        this.selected = []
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },
      savelabel () {
        // check to see if there are bags, it does not always refresh
        // ship all bags possible
        let securitybags = this.$store.getters.getLoadedPostalDeposits.filter(deposit => deposit.shipped !== true)
        this.selected = securitybags

        if (this.selected <= 0) {
          this.editedItem = this.defaultItem // reset values
          this.alertmessage = 'There were no contents to ship in package'
          this.snackbar = true
          this.dialog = false
          return
        }
        let securebagdeposit = { Name: 'Unsent', Amount: '0' } // we dont know whats in the bag yet
        let pickupday = moment().add(1, 'day').format('YYYY-MM-DD')
        let timezone = 'America/New_York'
        let tstart = pickupday + ' ' + '09:00'
        let tend = pickupday + ' ' + '16:00'
        let start = zonedTimeToUtc(tstart, timezone)
        let end = zonedTimeToUtc(tend, timezone)
        let rec = {
          siteid: this.sitedetails.idnum,
          safeid: this.id,
          contents: this.selected,
          used: false,
          securebagdeposit: '',
          timestamp: Date.now(),
          ship_date: pickupday,
          pickupstart: start.toISOString(),
          pickupend: end.toISOString(),
          sitedetails: this.sitedetails
        }
        this.editedItem = this.defaultItem // reset values
        this.alertmessage = 'Your shipment has been recorded, your label is being created'
        this.snackbar = true
        this.$store.dispatch('createPostalLabel', rec)

        this.dialog = false
        // this.$store.dispatch('loadpostalshipments', this.id)

        //  this.$store.dispatch('loadpostaldeposits', this.id)
        // this.$store.dispatch('loadpostaldeposits', this.$route.params.id)
      },
    },
  }
</script>
